import Vue from "vue";
import VueCompositionApi from "@vue/composition-api";
import Vuex from "vuex";
import {root} from "@/shared/store";
import {PortalTimelineWidgetState} from "@/apps/PortalTimelineWidget/models/portal-timeline-widget-state";
import PortalTimelineWidget from "@/apps/PortalTimelineWidget/components/PortalTimelineWidget.vue";
import mutations from "@/apps/PortalTimelineWidget/store/mutations";
import getters from "@/apps/PortalTimelineWidget/store/getters";
import actions from "@/apps/PortalTimelineWidget/store/actions";


Vue.use(VueCompositionApi);

Vue.config.productionTip = false;
Vue.config.silent = true;

let portalWidgetEle = document.querySelectorAll('widget-portal-timeline');
if (portalWidgetEle.length) {
    portalWidgetEle.forEach(el => {
        let store = new Vuex.Store({
            state: new PortalTimelineWidgetState(),
            mutations: mutations,
            getters: getters,
            actions: actions,
            modules: {
                root
            }
        })

        new Vue({
            el: el,
            store,
            render(h: any) {
                let title = this.$el.attributes.getNamedItem('title');
                let items = this.$el.attributes.getNamedItem('items');
                let labels = this.$el.attributes.getNamedItem('labels');

                return h(PortalTimelineWidget, {
                    props: {
                        title: title ? title.value : null,
                        items: items ? JSON.parse(items.value) : null,
                        labels: labels ? JSON.parse(labels.value) : null,
                    }
                })
            }
        });
    });
}
